// @flow
import fp from "lodash/fp"

import type {
  PriorityBoardingFlightOrdered,
  PriorityBoardingOrdered,
} from "booking/services/additionalServices/services/priorityBoarding/services/types"

/**
 * Takes object with keys (indexes),
 * remove the value under specified index
 * and move all values with bigger index down by one
 * e.g.: { 0: false, 1: true } => (removing index 0, new num is 1) => { 0: true }
 *
 * @param index - which passenger should be spliced
 * @param newNumOfPassengers - is important, because PBFlightOrdered might have incomplete data
 *
 * @return PriorityBoardingFlightOrdered => PriorityBoardingFlightOrdered - function which takes ordered data
 *  and returns ordered data with spliced passenger (under index)
 */
export const splicePassengersForFlight = (
  index: number,
  newNumOfPassengers: number,
): (PriorityBoardingFlightOrdered => PriorityBoardingFlightOrdered) =>
  fp.compose(
    // Take only first 0..newNumOfPassengers indexes, because the last one was removed
    // $FlowFixMe: error revealed by updating Flow and lodash libdef, please fix
    fp.pick(fp.range(0, newNumOfPassengers)),
    // remove {index} value and all bigger move by 1 down (splice functionality)
    ord =>
      fp.reduce(
        (acc, key) => fp.set([key], acc[key + 1] || false, acc),
        ord,
        fp.range(index, newNumOfPassengers),
      ),
  )

export const splicePassengersForFlights = (
  index: number,
  newNumOfPassengers: number,
  ordered: PriorityBoardingOrdered,
) => fp.mapValues(splicePassengersForFlight(index, newNumOfPassengers), ordered)
